import { RouteObject } from "react-router-dom";

export const productFeedbackRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Product feedback" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ProductFeedbackPage } =
            await import("./product-feedback-page");
          return { Component: ProductFeedbackPage };
        },
      },
    ],
  },
];
